// extracted by mini-css-extract-plugin
export default {"container":"ActiveMemories_container__iHgIv","allMemoriesButton":"ActiveMemories_allMemoriesButton__sxwVs"};